export default __webpack_public_path__ + "static/media/seascape.53f1c0b9.png";